(function () {
  'use strict';

  if (window.__cpcPacksCart) return;
  window.__cpcPacksCart = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;
  var TRASH = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M10.67 4v-.53c0-.75 0-1.12-.15-1.41a1.33 1.33 0 0 0-.58-.58C9.65 1.33 9.28 1.33 8.53 1.33H7.47c-.75 0-1.12 0-1.41.15-.25.13-.45.33-.58.58-.15.29-.15.66-.15 1.41V4M2 4h12M12.67 4v7.47c0 1.12 0 1.68-.22 2.11-.19.38-.5.68-.87.87-.43.22-.99.22-2.11.22H6.53c-1.12 0-1.68 0-2.11-.22a2 2 0 0 1-.87-.87c-.22-.43-.22-.99-.22-2.11V4"/></svg>';

  /* ---------- Semana Elixir (checkbox en la seccion) ----------
     30ml: pagas 3 y el 4to va gratis / 100ml: pagas 2 y el 3ro va gratis.
     El tamano lo define lo primero del carrito; si el carrito esta vacio,
     lo que el cliente elija en la pantalla "¿100ml o 30ml?". */
  var ELIXIR = {
    '100': { goal: 3, sub: 'Lleva 3 perfumes al precio de 2', ord: '3°', done: '¡Felicidades! Tu 3er perfume es gratis' },
    '30':  { goal: 4, sub: 'Lleva 4 perfumes al precio de 3', ord: '4°', done: '¡Felicidades! Tu 4to perfume es gratis' }
  };
  var ELIXIR_DEFAULT_SIZE = '100';
  var ELIXIR_KEY = 'cpcElixirSize';

  var excluded = new Set();
  var cart = null;
  var busy = false;

  /* ---------- utilidades ---------- */
  function readExcluded() {
    var el = document.querySelector('kaching-cart[kaching-cart-props]');
    if (!el) return;
    try {
      var p = JSON.parse(el.getAttribute('kaching-cart-props'));
      var tpb = p.cartSettings.tieredPromotionsBar;
      if (!tpb.excludeProductsFromUnlockCount) return;
      (tpb.productsExcludedFromUnlockCount || []).forEach(function (x) {
        excluded.add(String(x.productId).split('/').pop());
      });
    } catch (e) {}
  }

  function money(cents, fmt) {
    var n = (Math.abs(cents) / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    var flat = (Math.round(Math.abs(cents) / 100)).toLocaleString('es-MX');
    return (fmt || '$ {{amount}}')
      .replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, flat)
      .replace(/\{\{\s*amount[^}]*\}\}/, n);
  }

  function cfg(root) {
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
    tiers.sort(function (a, b) { return a.qty - b.qty; });
    return {
      tiers: tiers,
      slots: parseInt(root.getAttribute('data-slots') || '4', 10),
      fmt: root.getAttribute('data-money-format') || '$ {{amount}}',
      addUrl: root.getAttribute('data-add-url') || '/collections/all',
      elixir: root.getAttribute('data-elixir') === 'true'
    };
  }

  function names(root) {
    if (root.__cpcNames) return root.__cpcNames;
    var el = root.querySelector('[data-packs-names]');
    try { root.__cpcNames = JSON.parse(el.textContent); } catch (e) { root.__cpcNames = {}; }
    return root.__cpcNames;
  }

  function eligible(items) {
    return (items || []).filter(function (it) {
      return !excluded.has(String(it.product_id)) && it.original_line_price > 0;
    });
  }

  function detectSize(it) {
    var hay = [it.variant_title, it.product_title, it.title].join(' ');
    if (/100\s*ml/i.test(hay)) return '100';
    if (/\b30\s*ml/i.test(hay)) return '30';
    return null;
  }

  /* /cart.js lista lo mas reciente primero: el ultimo es el primero agregado */
  function cartSize(items) {
    for (var i = items.length - 1; i >= 0; i--) {
      var s = detectSize(items[i]);
      if (s) return s;
    }
    return null;
  }

  function storedSize() {
    try { return sessionStorage.getItem(ELIXIR_KEY); } catch (e) { return null; }
  }
  function storeSize(v) {
    try { sessionStorage.setItem(ELIXIR_KEY, v); } catch (e) {}
  }

  /* ---------- datos ---------- */
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; })
      .catch(function () { return null; });
  }

  function changeLine(key, qty) {
    if (busy) return Promise.resolve();
    if (window.cpcSuppressCart) window.cpcSuppressCart();
    busy = true;
    renderAll();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; })
      .catch(function () {})
      .then(function () {
        busy = false;
        renderAll();
        nudgeApps();
      });
  }

  function nudgeApps() {
    ['cart:refresh', 'cart:updated', 'shopify:cart:update'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });
    if (window.KachingCart && typeof window.KachingCart.refresh === 'function') {
      try { window.KachingCart.refresh(); } catch (e) {}
    }
  }

  /* ---------- render ---------- */
  function renderItems(root, c, map, items, showSlot, slotHint) {
    var wrap = root.querySelector('[data-packs-items]');
    var itemTpl = root.querySelector('[data-packs-item-tpl]');
    var slotTpl = root.querySelector('[data-packs-slot-tpl]');
    wrap.innerHTML = '';

    items.forEach(function (it) {
      var node = itemTpl.content.firstElementChild.cloneNode(true);
      var info = map[it.handle] || {};
      var short = info.short || String(it.product_title || it.title).split(' (')[0];
      var full = (info.full || it.product_title || it.title).replace(/[()]/g, '');

      var img = node.querySelector('.cpc-item__img');
      img.src = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      img.alt = short;

      node.querySelector('.cpc-item__name').textContent = short;
      node.querySelector('.cpc-item__title').textContent = full;
      node.querySelector('[data-qty]').textContent = it.quantity;
      node.querySelector('.cpc-item__price').textContent = money(it.original_line_price, c.fmt);

      var dec = node.querySelector('[data-act="dec"]');
      dec.innerHTML = it.quantity > 1 ? '−' : TRASH;
      dec.setAttribute('data-key', it.key);
      dec.setAttribute('data-next', it.quantity - 1);
      dec.setAttribute('aria-label', it.quantity > 1 ? 'Quitar una unidad' : 'Eliminar producto');

      var inc = node.querySelector('[data-act="inc"]');
      inc.setAttribute('data-key', it.key);
      inc.setAttribute('data-next', it.quantity + 1);

      node.classList.toggle('is-busy', busy);
      wrap.appendChild(node);
    });

    if (showSlot) {
      var slot = slotTpl.content.firstElementChild.cloneNode(true);
      slot.querySelector('.cpc-slot__hint').textContent = slotHint || '';
      wrap.appendChild(slot);
    }
  }

  function setSteps(root, total, active) {
    var stepsWrap = root.querySelector('[data-packs-steps]');
    if (!stepsWrap) return;
    if (stepsWrap.children.length !== total) {
      var h = '';
      for (var i = 0; i < total; i++) h += '<span class="cpc__step"></span>';
      stepsWrap.innerHTML = h;
    }
    for (var s = 0; s < stepsWrap.children.length; s++) {
      stepsWrap.children[s].classList.toggle('is-active', s < active);
    }
  }

  function setText(root, sel, html) {
    var el = root.querySelector(sel);
    if (el && el.innerHTML !== html) el.innerHTML = html;
  }

  /* Modo Semana Elixir */
  function renderElixir(root, c, map, items) {
    var inCart = cartSize(items);
    if (inCart) storeSize(inCart);
    var size = inCart || storedSize();

    if (!size || !ELIXIR[size]) {
      root.setAttribute('data-view', 'selector');
      root.setAttribute('data-qty', 0);
      return;
    }
    root.setAttribute('data-view', 'builder');

    var E = ELIXIR[size];
    var goal = E.goal;

    var qty = 0, original = 0, finalSum = 0, groupQty = 0;
    items.forEach(function (it) {
      qty += it.quantity;
      original += it.original_line_price;
      finalSum += it.final_line_price;
      if (detectSize(it) === size) groupQty += it.quantity;
    });
    var discount = original - finalSum;
    if (discount < 0) discount = 0;

    setText(root, '.cpc__subtitle', E.sub);

    var status;
    if (groupQty >= goal) {
      status = E.done;
    } else {
      var falta = groupQty === 0 ? goal - 1 : goal - groupQty;
      status = 'Agrega ' + falta + ' más y el ' + E.ord + ' va gratis';
    }
    setText(root, '[data-packs-status]', status);

    setSteps(root, goal, Math.min(groupQty, goal));

    renderItems(root, c, map, items, groupQty < goal, 'El ' + E.ord + ' va gratis');

    root.querySelector('[data-packs-discount]').textContent =
      discount > 0 ? '-' + money(discount, c.fmt) : money(0, c.fmt);
    root.querySelector('[data-packs-subtotal]').textContent = money(finalSum, c.fmt);
    root.setAttribute('data-qty', qty);
  }

  /* Modo original: tiers % */
  function renderTiers(root, c, map, items) {
    root.setAttribute('data-view', 'builder');

    var qty = 0, original = 0;
    items.forEach(function (it) { qty += it.quantity; original += it.original_line_price; });

    var pct = 0, nextTier = null;
    for (var i = 0; i < c.tiers.length; i++) {
      if (qty >= c.tiers[i].qty) pct = c.tiers[i].pct;
      else if (!nextTier) nextTier = c.tiers[i];
    }

    var discount = Math.round(original * pct / 100);
    var subtotal = original - discount;

    var status = '';
    if (qty === 0 && c.tiers[0]) {
      status = 'Agrega ' + c.tiers[0].qty + ' y obtén <strong>' + c.tiers[0].pct + '% OFF</strong>';
    } else if (nextTier) {
      var falta = nextTier.qty - qty;
      status = 'Agrega ' + falta + (falta === 1 ? ' mas' : ' mas') +
               ' y sube a <strong>' + nextTier.pct + '% OFF</strong>';
    } else {
      status = '¡Felicidades! Ahorraste <strong>' + money(discount, c.fmt) + '</strong>';
    }
    setText(root, '[data-packs-status]', status);

    setSteps(root, c.slots, Math.min(qty, c.slots));

    renderItems(root, c, map, items, qty < c.slots,
      nextTier ? 'Desbloquea ' + nextTier.pct + '% OFF' : '');

    root.querySelector('[data-packs-discount]').textContent =
      discount > 0 ? '-' + money(discount, c.fmt) : money(0, c.fmt);
    root.querySelector('[data-packs-subtotal]').textContent = money(subtotal, c.fmt);
    root.setAttribute('data-qty', qty);
  }

  function render(root) {
    if (!cart) return;

    var c = cfg(root);
    var map = names(root);
    var items = eligible(cart.items);

    if (c.elixir) renderElixir(root, c, map, items);
    else renderTiers(root, c, map, items);
  }

  function renderAll() {
    var roots = document.querySelectorAll('[data-packs-cart]');
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-packs-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-packs-cart]');
      var collapsed = root.getAttribute('data-collapsed') === 'true';
      root.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      return;
    }

    /* Selector Semana Elixir */
    var opt = e.target.closest && e.target.closest('[data-packs-size]');
    if (opt) {
      var optRoot = opt.closest('[data-packs-cart]');
      var opts = optRoot.querySelectorAll('[data-packs-size]');
      for (var o = 0; o < opts.length; o++) opts[o].classList.toggle('is-selected', opts[o] === opt);
      return;
    }

    var next = e.target.closest && e.target.closest('[data-packs-next]');
    if (next) {
      var nextRoot = next.closest('[data-packs-cart]');
      var sel = nextRoot.querySelector('[data-packs-size].is-selected');
      storeSize(sel ? sel.getAttribute('data-packs-size') : ELIXIR_DEFAULT_SIZE);
      renderAll();
      return;
    }

    var btn = e.target.closest && e.target.closest('[data-act]');
    if (!btn || !btn.closest('[data-packs-cart]')) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-next'), 10));
  });

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { loadCart().then(renderAll); }, delay == null ? 200 : delay);
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
    var res = _fetch.apply(this, arguments);
    if (CART_MUTATION.test(url)) res.then(function () { refresh(150); refresh(800); }, function () {});
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cpcUrl = String(u || ''); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_MUTATION.test(this.__cpcUrl || '')) {
      this.addEventListener('loadend', function () { refresh(150); refresh(800); });
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh(0);
  });

  readExcluded();
  loadCart().then(renderAll);
  setInterval(function () { if (!document.hidden) refresh(0); }, 8000);
})();

(function () {
  'use strict';

  if (window.__cpcNoDrawer) return;
  window.__cpcNoDrawer = true;

  var SCOPE = '.custom-packs-collections';
  var WINDOW_MS = 2500;
  var until = 0;
  var offTimer = null;

  function arm() {
    until = Date.now() + WINDOW_MS;
    document.documentElement.classList.add('cpc-suppress-cart');
    clearTimeout(offTimer);
    offTimer = setTimeout(disarm, WINDOW_MS);
  }

  function disarm() {
    until = 0;
    clearTimeout(offTimer);
    document.documentElement.classList.remove('cpc-suppress-cart');
  }

  function armed() { return Date.now() < until; }

  window.cpcSuppressCart = arm;

  // 1. Armar cuando el ATC nace dentro del pack
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], .quick-add__submit, [data-act]');
    if (btn && btn.closest(SCOPE)) arm();
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest(SCOPE)) arm();
  }, true);

  // 2. Cerrar cualquier drawer que se abra durante la ventana
  function closeDrawers() {
    if (!armed()) return;

    var k = document.querySelector('#kaching-cart[data-open="true"], #kaching-cart.active');
    if (k) {
      var close = k.querySelector('.kaching-cart__close');
      if (close) close.click();
      else k.classList.remove('active');
    }

    var themeDrawer = document.querySelector('cart-drawer.active, cart-drawer.animate.active');
    if (themeDrawer && typeof themeDrawer.close === 'function') themeDrawer.close();

    if (k || themeDrawer) setTimeout(disarm, 300);
  }

  new MutationObserver(closeDrawers).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'data-open', 'open', 'style']
  });
})();

(function () {
  'use strict';

  if (window.__plCardExtraInfo) return;
  window.__plCardExtraInfo = true;

  /* Copy bajo cada product card (.custom-extra-info).
     Con "Semana Elixir" activo en la seccion usa los copies de la promo
     gratis; si no, los tiers % originales. */
  var TIERS = ['10% OFF', '15% OFF', '20% OFF']; // con 1, 2 y 3 en el carrito
  var MAX = 4;
  var EXCLUIR = []; // ids de producto que no cuentan (ej. el mini perfume de regalo)

  var ELIXIR = {
    '100': { goal: 3, ord: 'el tercero', done: 'tercer' },
    '30':  { goal: 4, ord: 'el cuarto',  done: 'cuarto' }
  };
  var ELIXIR_DEFAULT_SIZE = '100';
  var ELIXIR_KEY = 'cpcElixirSize';

  var S = { qty: null, group: null, groupQty: 0 };

  function elixirOn() {
    var el = document.querySelector('[data-packs-cart]');
    return !!(el && el.getAttribute('data-elixir') === 'true');
  }

  function detectSize(it) {
    var hay = [it.variant_title, it.product_title, it.title].join(' ');
    if (/100\s*ml/i.test(hay)) return '100';
    if (/\b30\s*ml/i.test(hay)) return '30';
    return null;
  }

  function storedSize() {
    try { return sessionStorage.getItem(ELIXIR_KEY); } catch (e) { return null; }
  }

  function html() {
    if (S.qty === null) return null;

    if (!elixirOn()) {
      var q = S.qty;
      if (!q) return '';
      if (q >= MAX) return 'Tienes <span>20% OFF</span>';
      return 'Agrega 1 más y obtén <span>' + TIERS[q - 1] + '</span>';
    }

    var size = S.group || storedSize() || ELIXIR_DEFAULT_SIZE;
    var E = ELIXIR[size];
    if (!E) return '';
    var gq = S.group ? S.groupQty : 0;
    if (gq >= E.goal) return 'Obtuviste tu <span>' + E.done + ' perfume gratis</span>';
    var falta = gq === 0 ? E.goal - 1 : E.goal - gq;
    return 'Agrega ' + falta + ' más y <span>' + E.ord + ' va gratis</span>';
  }

  function paint() {
    var h = html();
    if (h === null) return;
    var nodos = document.querySelectorAll('.custom-extra-info');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].innerHTML !== h) nodos[i].innerHTML = h;
    }
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (it) {
          if (EXCLUIR.indexOf(it.product_id) !== -1) return false;
          return it.original_line_price > 0; // líneas en $0 fuera
        });
        var n = 0;
        items.forEach(function (it) { n += it.quantity; });

        /* lo mas reciente primero: el ultimo es el primero agregado */
        var g = null;
        for (var i = items.length - 1; i >= 0; i--) {
          g = detectSize(items[i]);
          if (g) break;
        }
        var gq = 0;
        if (g) {
          items.forEach(function (it) {
            if (detectSize(it) === g) gq += it.quantity;
          });
        }
        S.qty = n;
        S.group = g;
        S.groupQty = gq;
      })
      .catch(function () {});
  }

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { loadCart().then(paint); }, delay == null ? 250 : delay);
  }

  // Cualquier mutación del carrito por AJAX
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
    var isCart = /\/cart(\/|\.js|\?|$)/.test(url);
    var res = _fetch.apply(this, arguments);
    if (isCart) { res.then(function () { refresh(120); refresh(700); }, function () {}); }
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__plUrl = String(u || ''); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart(\/|\.js|\?|$)/.test(this.__plUrl || '')) {
      this.addEventListener('loadend', function () { refresh(120); refresh(700); });
    }
    return _send.apply(this, arguments);
  };

  // Cards que se repintan (filtros de colección, quick add)
  var raf = null;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  refresh(0);
})();
